module.exports = __webpack_public_path__ + "static/media/Supabase.67f3074a.png";